import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ButtonWithIcon } from '@els/els-react--button';
import { ModalPanel } from '@els/els-react--modal-panel';
import AppStorage from '@Services/AppStorage';
import { QUICK_SEARCH_TRACKING_BUTTON_TYPES, trackQuickSearchButtonClick } from '../analytics';
import SearchTipsModalContent from './SearchTipsModalContent/SearchTipsModalContent';

import './SearchTips.scss';

function SearchTips({ updateInputText, onExampleApplied }) {
  const [showSearchTips, setShowSearchTips] = useState(false);

  const handleExampleClick = (exampleText) => {
    updateInputText(exampleText);
    onExampleApplied();
    setShowSearchTips(false);
    AppStorage.instance.setToSessionStorage('quickSearchExampleUsed', exampleText);
  };

  return (
    <div className="search-tips">
      <ButtonWithIcon
        type="link"
        linkIconSize="xs"
        iconRight
        sprite="InformationOutlineCircle"
        data-e2e="search-tips-button"
        onClick={() => {
          trackQuickSearchButtonClick(QUICK_SEARCH_TRACKING_BUTTON_TYPES.learnHowItWorks);
          setShowSearchTips(!showSearchTips);
        }}>
        Learn how it works
      </ButtonWithIcon>
      {showSearchTips && (
        <ModalPanel
          className="c-els-modal--panel-custom"
          panelPosition="right"
          modalProps={{
            onClose: () => {
              setShowSearchTips(false);
            },
            label: 'Learn how it works',
          }}>
          <SearchTipsModalContent onExampleClick={handleExampleClick} />
        </ModalPanel>
      )}
    </div>
  );
}

SearchTips.propTypes = {
  updateInputText: PropTypes.func.isRequired,
  onExampleApplied: PropTypes.func,
};

SearchTips.defaultProps = {
  onExampleApplied: () => {},
};

export default SearchTips;
